export default {
    STATUTE: 'weight_unit_statute',
    STATUTE_UK: 'weight_unit_statute_uk',
    METRIC: 'weight_unit_metric'
};
